import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { SEAT_TYPE_OPTIONS } from '@/screens/PlaceReviewFormScreen/constants';
import { EmptyStateCard } from './AccessibilityInfoComponents';
export default function PlaceReviewSection({ reviews, title = '내부 이용 정보', showDate = true, onRegister, }) {
    if (reviews.length === 0) {
        return (_jsxs(SectionContainer, { children: [_jsx(SectionHeader, { children: _jsx(SectionTitle, { children: title }) }), _jsx(EmptyStateCard, { title: '아직 등록된 방문 리뷰가 없어요🥲', description: '장소 내부 리뷰는 공간 이용 여부를\n결정할 수 있는 중요한 정보에요!', buttonText: "\uB0B4\uBD80 \uB9AC\uBDF0 \uC791\uC131\uD558\uAE30", onPress: onRegister })] }));
    }
    const updatedAt = dayjs(Math.max(...reviews.map(r => r.createdAt.value))).format('YYYY.MM.DD');
    const allSeatTypes = [...new Set(reviews.flatMap(r => r.seatTypes))];
    const seatTypes = [];
    const seatComments = [];
    allSeatTypes.forEach(item => {
        if (SEAT_TYPE_OPTIONS.includes(item)) {
            seatTypes.push(item);
        }
        else {
            seatComments.push(item);
        }
    });
    const orderMethods = [...new Set(reviews.flatMap(r => r.orderMethods))];
    const features = [...new Set(reviews.flatMap(r => { var _a; return (_a = r.features) !== null && _a !== void 0 ? _a : []; }))];
    const hasData = seatTypes.length > 0 || orderMethods.length > 0 || features.length > 0;
    if (!hasData) {
        return (_jsxs(SectionContainer, { children: [_jsx(SectionHeader, { children: _jsx(SectionTitle, { children: title }) }), _jsx(EmptyStateCard, { title: '아직 등록된 방문 리뷰가 없어요🥲', description: '장소 내부 리뷰는 공간 이용 여부를\n결정할 수 있는 중요한 정보에요!', buttonText: "\uB0B4\uBD80 \uB9AC\uBDF0 \uC791\uC131\uD558\uAE30", onPress: onRegister })] }));
    }
    return (_jsxs(SectionContainer, { children: [_jsxs(SectionHeader, { children: [_jsx(SectionTitle, { children: title }), showDate && _jsx(SectionDate, { children: updatedAt })] }), _jsxs(IndoorContent, { children: [seatTypes.length > 0 && (_jsxs(IndoorRow, { children: [_jsx(IndoorLabel, { children: "\uC88C\uC11D \uAD6C\uC131" }), _jsxs(IndoorValueContainer, { children: [_jsx(TagWrap, { children: seatTypes.map(t => (_jsx(Tag, { children: _jsx(TagText, { children: t }) }, t))) }), seatComments.length > 0 && (_jsx(IndoorDescription, { children: seatComments.join(', ') }))] })] })), orderMethods.length > 0 && (_jsxs(IndoorRow, { children: [_jsx(IndoorLabel, { children: "\uC8FC\uBB38\uBC29\uBC95" }), _jsx(IndoorValueContainer, { children: _jsx(TagWrap, { children: orderMethods.map(m => (_jsx(Tag, { children: _jsx(TagText, { children: m }) }, m))) }) })] })), features.length > 0 && (_jsxs(IndoorRow, { children: [_jsx(IndoorLabel, { children: "\uD2B9\uC774\uC0AC\uD56D" }), _jsx(IndoorValueContainer, { children: _jsx(IndoorFeatureText, { children: features.join(', ') }) })] }))] })] }));
}
// ──────────────── Styled Components ────────────────
const SectionContainer = styled.View `
  gap: 16px;
`;
const SectionHeader = styled.View `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const SectionTitle = styled.Text `
  font-family: ${font.pretendardSemibold};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: ${color.gray90};
`;
const SectionDate = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${color.gray50};
`;
const IndoorContent = styled.View `
  gap: 16px;
`;
const IndoorRow = styled.View `
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
`;
const IndoorLabel = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${color.gray40};
  width: 48px;
  padding-top: 4px;
`;
const IndoorValueContainer = styled.View `
  flex: 1;
  gap: 8px;
`;
const TagWrap = styled.View `
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;
const Tag = styled.View `
  background-color: ${color.gray5};
  border-radius: 6px;
  padding-horizontal: 6px;
  padding-vertical: 4px;
`;
const TagText = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${color.brand50};
`;
const IndoorDescription = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 13px;
  line-height: 20px;
  color: ${color.gray90};
`;
const IndoorFeatureText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.28px;
  color: ${color.gray90};
`;
